import { useRef } from "react"
import { accordionUniqueId } from "@/utils/index"

const COLLAPSIBLE_ID_MAX = 9999
const COLLAPSIBLE_ID_MIN = 1000

const usePDPAccordionCollapsibleId = () => {
  const triggerIdRef = useRef(
    accordionUniqueId(
      "collapsible-trigger",
      COLLAPSIBLE_ID_MAX,
      COLLAPSIBLE_ID_MIN
    )
  )
  const contentIdRef = useRef(
    accordionUniqueId(
      "collapsible-content",
      COLLAPSIBLE_ID_MAX,
      COLLAPSIBLE_ID_MIN
    )
  )

  return {
    collapsibleTriggerId: triggerIdRef.current,
    collapsibleContentId: contentIdRef.current,
  }
}

export default usePDPAccordionCollapsibleId
